import { Locale } from "antd/es/locale";
import ptBR from "antd/locale/pt_BR";
import enUS from "antd/locale/en_US";
import esES from "antd/locale/es_ES";
import frFR from "antd/locale/fr_FR";
import deDE from "antd/locale/de_DE";

export const getAntdLocale = (language: string): Locale => {
  switch (language) {
    case "ptBr":
    case "pt":
      return ptBR;
    case "es":
      return esES;
    case "fr":
      return frFR;
    case "de":
      return deDE;
    case "en":
    default:
      return enUS;
  }
};
